/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindphone3Inputs */

const en_listingbuttonskindphone3 = /** @type {(inputs: Listingbuttonskindphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

const de_listingbuttonskindphone3 = /** @type {(inputs: Listingbuttonskindphone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrufen`)
};

/**
* | output |
* | --- |
* | "Call" |
*
* @param {Listingbuttonskindphone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindphone3 = /** @type {((inputs?: Listingbuttonskindphone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindphone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindphone3(inputs)
	return de_listingbuttonskindphone3(inputs)
});
export { listingbuttonskindphone3 as "listingButtonsKindPhone" }